import { render } from "./HeaderComponent.vue?vue&type=template&id=586f1ed6"
import script from "./HeaderComponent.vue?vue&type=script&lang=js"
export * from "./HeaderComponent.vue?vue&type=script&lang=js"
script.render = render

export default script